window.DocDeposit = {

	numformat	: {'name': "", 'currency': "", 'decimals': ".", 'thousands': "", 'currencypos': "", 'precision': ""},
	vat			: null,
	formId		: 'docDepositForm',
	useTax		: null,

	init: function() {

		// init numberformat from doc inputs
		this.numformat.name			= $('input[name=numformat_name]').val();
		this.numformat.currency		= $('input[name=numformat_currency]').val();
		this.numformat.decimals		= $('input[name=numformat_decimals]').val();
		this.numformat.thousands	= $('input[name=numformat_thousands]').val();
		this.numformat.currencypos	= $('input[name=numformat_currencypos]').val();
		this.numformat.precision	= $('input[name=numformat_precision]').val();

		// init vat depending of parent vat
		this.vat					= $('input[name=hasVat]').val() == 'Y';

		// init keyup events
		$("#" + DocDeposit.formId + " input.updateRow.amountDisplay").bind("keyup", function() {
			DocDeposit.updateAmounts(this,'amount');
		});
		$("#" + DocDeposit.formId + " input.updateRow.percent").bind("keyup", function() {
			DocDeposit.updateAmounts(this,'percent');
		});

		$('#useTaxOnDeposit').on('change', function() {
			DocDeposit.useTax = ($('#useTaxOnDeposit').is(":checked"));
			$('#hasVat').val( (DocDeposit.useTax) ? 'Y' : 'N');

			if (DocDeposit.useTax) {
					$('.taxLabelText').show();
					$('.noTaxLabelText').hide();
			} else {
					$('.taxLabelText').hide();
					$('.noTaxLabelText').show();
			}

			//When checkbox useTaxOnDeposit changes, fill amount input with taxesFree or taxesinc value
			$("#" + DocDeposit.formId + " input.updateRow.amountDisplay").each(function(i, elt){
				$elt = $(elt).not(":disabled");
				const position = $elt.attr('position');
				DocDeposit.useTax
					? $elt.val(
						NumberFormat.formatToDisplay($("#current_deposit_amount_ttc_" + position).val(), DocDeposit.numformat)
					)
					: $elt.val(
						NumberFormat.formatToDisplay($("#current_deposit_amount_ht_" + position).val(), DocDeposit.numformat)
					)
				;
			});

			$("#" + DocDeposit.formId + " input.updateRow.amountDisplay").trigger('keyup');
		});

		$("#deposit_ident").on('change', function(){
			$("#deposit_identHasChanged").val("1");
		});

		MyFacture.initEvent();
		$('#useTaxOnDeposit').change();
		MyTabs.initHorizontal('cguform');

		//trigger a change for update totals
		$("#" + DocDeposit.formId + " input.updateRow.amountDisplay").trigger('keyup');
	},

    /**
	 * Update amounts data
     * @param dataAmount	input of one line
     * @param type			amount/percent depending on which action triggers update
     */
	updateAmounts: function(dataAmount, type) {
        var data	= DocDeposit.baseAmounts(dataAmount);

        data		= DocDeposit.processAmounts(dataAmount, type, data);
        DocDeposit.processToDisplay(data, type);

        data		= DocDeposit.processTotals(data);
        DocDeposit.processToDisplayTotals(data);
	},

	baseAmounts: function(element) {
		var positionId				= $(element).attr("position");

		// doc parent infos
		var parentDoc				= Persistent.get('docParent', true, true);
		var parentTotalAmount		= new Big( NumberFormat.formatToFloat($("#deposit_amountLeft").val(), DocDeposit.numformat ));

		var rowTotalAmount			= DocDeposit.useTax ? new Big($("#deposit_amountDueTTC_" + positionId).val()) : new Big($("#deposit_amountDueHT_" + positionId).val());

		return {
			deposit: {
				ht		: Big(0),
				ttc		: Big(0),
				vat		: Big(0),
				percent	: Big(0)
			},
			total: {
				ht		: Big(0),
				ttc		: Big(0)
			},
			position: positionId,
			parent: {
				doc: parentDoc,
				amount: parentTotalAmount
			},
			totalAmount: rowTotalAmount,
		};
	},

	processAmounts: function(element, input, data) {
		var datas = data;
		let rowAmount;

		switch(input) {
			case 'amount':

				var rawDepositAmount = NumberFormat.formatToFloat($(element).val(), DocDeposit.numformat);
				var depositAmount = new Big(rawDepositAmount);

				if (DocDeposit.vat) {
					datas.deposit.vat	= Big(parseFloat($('#deposit_taxid_' + datas.position).attr('rate'), 10));
				}

				if (DocDeposit.vat && DocDeposit.useTax) {
					datas.deposit.ttc	= depositAmount.round(parseInt(DocDeposit.numformat.precision, 10));
					datas.deposit.ht	= depositAmount.div((datas.deposit.vat).div(100).plus(1)).round(parseInt(DocDeposit.numformat.precision, 10));
					rowAmount			= datas.deposit.ttc;
				} else {
					datas.deposit.ht	= depositAmount.round(parseInt(DocDeposit.numformat.precision, 10));
					datas.deposit.ttc	= depositAmount.mul((datas.deposit.vat).div(100).plus(1)).round(parseInt(DocDeposit.numformat.precision, 10));
					rowAmount			= datas.deposit.ht;
				}

				// calc percent
				var rowAmountDue		= datas.totalAmount;
				datas.deposit.percent	= rowAmountDue.toString() == 0 ? 0 : rowAmount.times(100).div(rowAmountDue).round(parseInt(DocDeposit.numformat.precision, 10));
				break;
			case 'percent':
				// user input
				var rawPercent = NumberFormat.formatToFloat($(element).val(), DocDeposit.numformat);
				datas.deposit.percent = new Big(rawPercent);

				let $amount = DocDeposit.useTax ? $('#deposit_amountTaxesInc_' + datas.position) : $('#deposit_amount_' + datas.position);
				var baseAmount= new Big(datas.deposit.percent * (datas.totalAmount.div(100)));

				// calc old percent
				var currentAmount		= $amount.val() == '' ? 0 : parseFloat($amount.val(), 10);
				rowAmount			= new Big(currentAmount);
				var rowAmountDue		= datas.totalAmount;

				var currentPercent		= rowAmountDue.toString() == 0 ? (new Big(0)) : rowAmount.times(100).div(rowAmountDue);
				var roundedPercent		= currentPercent.round(parseInt(DocDeposit.numformat.precision, 10));

				// if we've same percent, we just keep the old baseValue
				if(datas.deposit.percent.cmp(roundedPercent) == 0) {
					baseAmount			= new Big($amount.val() == '' ? 0 : parseFloat($amount.val(),10));
				}

				if (DocDeposit.vat && DocDeposit.useTax && $('#deposit_taxid_' + datas.position).attr('rate') !== '') {
					datas.deposit.vat	= new Big(parseFloat($('#deposit_taxid_' + datas.position).attr('rate'), 10));
					datas.deposit.ht	= new Big(baseAmount.div((datas.deposit.vat).div(100).plus(1)));
					datas.deposit.ttc	= baseAmount;
				} else {
					datas.deposit.ttc	= new Big(baseAmount.mul((datas.deposit.vat).div(100).plus(1)));
					datas.deposit.ht	= baseAmount;
				}
				break;
		}
		return datas;
	},

	processTotals: function(data) {
		var datas = data;

		$("input.unitAmountTaxesInc").each(function(index, elem) {
			var line = $(elem).val() == '' ? Big(0) : Big(parseFloat($(elem).val(),10));
			datas.total.ttc = datas.total.ttc.plus(line);
		});

		$("input.unitAmountTaxesFree").each(function(index, elem) {
			var line = $(elem).val() == '' ? Big(0) : Big(parseFloat($(elem).val(), 10));
			datas.total.ht	= datas.total.ht.plus(line);
		});

	   return datas;
	},

	processToDisplay: function(datas, type) {
		// if the maximum is reached, we put a red box on the input
		const amountToCheck = DocDeposit.useTax ? datas.deposit.ttc : datas.deposit.ht;
		if(datas.totalAmount.minus(amountToCheck) < 0) {
			$('#deposit_row_amountDisplay_' + datas.position).addClass('red');
		} else if($('#deposit_row_amountDisplay_' + datas.position).hasClass('red')){
			$('#deposit_row_amountDisplay_' + datas.position).removeClass('red');
		}

		switch(type) {
			case 'amount':
				$("#" + DocDeposit.formId + " #deposit_percent_" + datas.position).val(NumberFormat.formatToDisplay((datas.deposit.percent).toString(), DocDeposit.numformat));
				break;
			case 'percent':
					$("#deposit_row_amountDisplay_" + datas.position).val(NumberFormat.formatToDisplay(Big(datas.deposit.ttc).round(parseInt(DocDeposit.numformat.precision, 10)), DocDeposit.numformat), true);
				break;
		}

		if (DocDeposit.useTax) {
			$("#deposit_amount_" + datas.position).val(datas.deposit.ht.toString());
			$("#deposit_amountTaxesInc_" + datas.position).val(datas.deposit.ttc.toString());
		} else {
			$("#deposit_amount_" + datas.position).val(datas.deposit.ht.toString());
			$("#deposit_amountTaxesInc_" + datas.position).val(datas.deposit.ht.toString());
		}

		$("#current_deposit_amount_ttc_" + datas.position).val(datas.deposit.ttc.toString());
		$("#current_deposit_amount_ht_" + datas.position).val(datas.deposit.ht.toString());
	},

	processToDisplayTotals: function(datas) {
		// Total restant à solder
		var newAmountLeft = (datas.parent.amount).minus(datas.total.ttc);
		$("#amountLeft").html(NumberFormat.formatToDisplay(newAmountLeft.toString(), DocDeposit.numformat));

		// total percentage left
		var newPercentLeft = newAmountLeft.times(100).div(datas.parent.doc.totalAmount);
		$("#percentLeft").html(NumberFormat.formatToDisplay(newPercentLeft.toString(), DocDeposit.numformat));

		// totals
		if (DocDeposit.useTax) {
			$("#totalRows").html(NumberFormat.formatToDisplay(datas.total.ttc, DocOverview.numformat));
			$("#totalRowsHT").html(NumberFormat.formatToDisplay(datas.total.ht, DocOverview.numformat));
		} else {
			$("#totalRows").html(NumberFormat.formatToDisplay(datas.total.ht, DocOverview.numformat));
			$("#totalRowsHT").html(NumberFormat.formatToDisplay(datas.total.ht, DocOverview.numformat));
		}
	}

}